import FAQs from "./FAQ";

export default FAQs;
